import _ from 'lodash';
import { container } from '@intigral/domain/lib/DataDomain';
import { DI } from '@intigral/constant/config/DIContainer';
import user from '../../helpers/user';
import { IBookmarkService } from '@intigral/domain/lib/application/services/BookmarkService';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { invalidateTaContinueWatchingFeeds } from '../data/taFeedQueryKeys';

export const useAddBookmarkMutation = () => {
    const queryClient = useQueryClient();
    return useMutation({
        mutationFn: async (params: any) => {
            try {
                const { bookmark, timeCode, duration, gamification } = params;
                const mediaId = bookmark.category === 'VOD' ? bookmark.mediaId : bookmark.listingId;
                const Id = bookmark.category === 'VOD' ? bookmark.Id : bookmark.paId;

                const bookmarkService = container.resolve<IBookmarkService>(DI.SERVICES.IBookmarkService);
                const payload: any = {
                    assetid: mediaId,
                    paId: Id,
                    timecode: timeCode,
                    duration,
                    programType: bookmark.category?.toLowerCase(),
                    // Gamification fields
                    ...(gamification?.epochMs && { epochMs: gamification.epochMs }),
                    ...(gamification?.segments && { segments: gamification.segments }),
                    ...(gamification?.requestId && { requestId: gamification.requestId }),
                    ...(gamification?.token && { token: gamification.token }),
                };
                await bookmarkService.addBookmark(
                    user.getAPIKey(),
                    user.getProfile()?.profileGuid,
                    payload,
                    user.getUserToken(),
                    user.getIdentityToken(),
                    gamification?.isGamificationEnabled || false
                );
                return {
                    ItemToDispatch: bookmark,
                    timeCode: timeCode,
                    duration,
                };
            } catch (error) {
                throw error.message;
            }
        },
        onSuccess: () => {
            queryClient.invalidateQueries({
                queryKey: ['profiles', 'bookmarks'],
            });
            invalidateTaContinueWatchingFeeds(queryClient);
        },
    });
};
